const BaseConstants = {
  YES: "Y",
  NO: "N",
  TRUE: "T",
  FALSE: "F"
};

const UserPreferences = {
  DEFAULT_LANGUAGE: "bs"
};

const HttpConstants = {
  HTTP_GET_METHOD: "get",
  HTTP_POST_METHOD: "post",
  HTTP_PUT_METHOD: "put",
  HTTP_DELETE_METHOD: "delete",
  JSON_CONTENT_TYPE: "application/json",
  FORM_CONTENT_TYPE: "application/x-www-form-urlencoded",
  MULTIPART_CONTENT_TYPE: "multipart/form-data",
  AUTH_HEADER: "Authorization",
  HTTP_CLIENT_ERROR_CODE: "CLIENT_ERROR",
  HTTP_SERVER_ERROR_CODE: "SERVER_ERROR",
  HTTP_SERVER_ERROR_MESSAGE: "HTTP_ERROR",
  CONTENT_TYPE_HEADER_NAME: "Content-Type",
  SESSION_ID_HEADER: "session-id",
  CSRF_TOKEN_HEADER_NAME: "X-XSRF-TOKEN",
  CSRF_TOKEN_COOKIE_NAME: "XSRF-TOKEN"
};

const RouteTypes = {
  ROOT: "root",
  SINGLETON: "singleton",
  TRANSIENT: "transient",
  REGULAR: "regular"
};

const Layouts = {
  DEFAULT: "app",
  ROOT: "root",
  APP: "app",
  BASE: "base"
};

const Topics = {
  DEFAULT: "app"
};

const Errors = {
  ERROR: "Error",
  VERIFICATION_REQUIRED: "verification-required",
  LOGIN_ERROR: "login-error",
  INVALID_CODE: "invalid-code",
  FORBIDDEN_STATUS: 403,
  INVALID_TOKEN: "invalid-token"
};

const PaymentTypeConstants = {
  UPP: "DOMESTIC",
  INO: "ABROAD",
  TRANSFER: "TRANSFER"
};

const FieldConstraints = {
  TextArea: {
    MIN_ROWS: 3,
    MAX_ROWS: 4
  },
  Input: {
    MAX_LENGTH: 30
  }
};

const DateFormats = {
  DATETIME_LOCAL: "DD.MM.YYYY kk:mm:ss",
  BASIC_DATETIME: "DD.MM.YYYY hh:mm:ss",
  BASIC_DATE: "DD.MM.YYYY"
};

const DevicesConstants = {
  REGISTRATION_DATE: "registrationDate",
  DESCRIPTION: "description",
  APP_ID: "appId",
  REMOVE_DEVICE: "removeDevice"
};

const CredentialsForm = {
  Fields: {
    USERNAME: "username",
    PASSWORD: "password"
  }
};

const PaymentInstructionTypes = {
  UPP: "DOMESTIC",
  INO: "ABROAD",
  UPP_INO: "DOMESTIC_ABROAD"
};

const PaymentConfirmationConstants = {
  DEFAULT_CURRENCY_UPP: "KM",
  AMOUNT_DECIMAL_PRECISION: 2
};

const StorageConstants = {
  LOGGED_IN: "logged_in",
  USERNAME: "username",
  PASSWORD: "password",
  DEVICES: "devices",
  LANGUAGE: "language"
};

const DeviceTableConstants = {
  MIN_PAGE_SIZE: 10,
  PAGE_SIZE: 10
};

const LanguageCodes = {
  BS: "bs",
  EN: "en"
};

const EnvConstants = {
  TRUE: "true"
};

export { Topics };
export { Layouts };
export { RouteTypes };
export { UserPreferences };
export { HttpConstants };
export { BaseConstants as Constants };
export { Errors };
export { PaymentTypeConstants };
export { FieldConstraints };
export { DevicesConstants };
export { CredentialsForm };
export { DateFormats };
export { PaymentInstructionTypes };
export { PaymentConfirmationConstants };
export { StorageConstants };
export { DeviceTableConstants };
export { LanguageCodes };
export { EnvConstants };
